
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const neve1073dpa: IProductData = {
  id: "neve-1073dpa",
  name: "Neve Dual Mic Preamp",
  description: "The 1073DPA provides two Class A Neve® 1073® microphone preampliﬁers in single rack space, without the additional EQ found on the classic 1073 unit – offering the very essence of the legendary 1073 sound.",
  specialOrder: true,
  images: ["/img/neve_1073dpa_front.png", "/img/neve_1073dpa_back.png"],
  details: [{
    label: "Description",
    markdown: `
Exclusive Marinair® transformers are used on the input and output stage to produce that classic 1073® sound.

The 1073DPA retains the discrete, class-A topology made famous by the classic 1073. The discrete audio path is constructed using through-hole methods, including mounting the Marinair® transformers and class-A transistor-based amplifiers.

The classic 5dB stepped Elma switch delivers accurate gain levels throughout the gain range. This unique layout means there is no need for a mic/line switch as the pot itself selects the preamp and input. Three distinct gain stages provided by two independent transistor-based preamplifiers provide gain for any DI, line input or microphone signal.

The 1073® preamp produces up to 80dB of microphone gain. By combining multiple gain stages and utilising the output trim control, the 1073DPA can be driven hard, bringing out the musical drive and harmonic saturation for which the 1073 is famous.

The 1073DPA impedance can be optimised for a wide range of modern or vintage microphones, with quickly selectable settings of 1.2kΩ and 300Ω.

The 180-degree phase flip feature is handy in multi-microphone setups with multiple preamps, ideal for top and bottom snare micing.
`
    }, {
      label: "Specifications",
      markdown: `
• Two legendary 1073®  microphone preamps in a convenient 1U rackmount design
• Hand-crafted and hand-wired by Neve in Burnley, UK
• Exclusive Neve® Marinair® transformers used on input and output stages
• Dedicated input Gain controls and output Trim controls on both channels
• +48V Phantom Power and Phase Reverse switch
• High-quality Input Selector switch
`
}, {
  label: "Audio Performance",
  markdown: `
• Input Impedance: Mic – Switchable, 300 or 1200 Ohms – Line – 20k Ohms
• Frequency Response: 60dB gain into 600 Ohms 20Hz to 20kHz (+/-0.5dB)  – 60dB gain into 600 Ohms 10Hz to 40kHz (-3dB)
• EIN: Mic 60dB gain <-125dB (22Hz to 22Hz bandwidth)
• THD+Noise: +20dBu into 600 Ohms <0.07% (50Hz to 10kHz) (80kHz bandwidth)
`
  }, {
    label: "Dimensions",
    markdown: `
• Width: 48.2cm (19 inches)
• Height: 45mm (1.75 inches) (1U)
• Depth: 254mm (10 inches)
• Weight: 5kg (11 pounds)
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.ams-neve.com/outboard/1073-range/1073dpa/" target="_blank">https://www.ams-neve.com/outboard/1073-range/1073dpa/</a>
    `
  }],
  metadata: {
    hashtags: [HASHTAGS.MICPRE, HASHTAGS.RECORDING, HASHTAGS.LIVE_SOUND, HASHTAGS.ONE_U, HASHTAGS.RACK],
    manufacturer: BRAND.NEVE,
  },
  videos: []
}